import i18next from 'i18next';
import { locales } from 'configs/i18n';

/* ------------------------------------- English ------------------------------------- */

i18next.addResources(locales.EN, 'BLOCKS_SHOW', {
  TITLE: 'Blocks',
  NAME: 'Name',
  LOADING: 'Loading...',
});

/* ------------------------------------- Spanish ------------------------------------- */

i18next.addResources(locales.ES, 'BLOCKS_SHOW', {
  TITLE: 'Manzanas',
  NAME: 'Nombre',
  LOADING: 'Cargando...',
});
